<template>
    <DxDataGrid :ref="liniiDataGrid" :allow-column-reordering="true" :data-source="dsLiniiDocumente" :allow-column-resizing="true" :column-auto-width="false"
    :column-min-width="50" :column-resizing-mode="'nextColumn'" :show-borders="true" :sync-lookup-filter-values="false" :filter-sync-enabled="true" @row-dbl-click="onRowDblClick">
        <DxExport :enabled="true" :formats="['pdf', 'xlsx']" :load-panel="{ enabled: true, showIndicator: true, text: 'Loading...' }"/>
        <DxFilterRow :visible="true"/>
        <DxGrouping :context-menu-enabled="true">
            <DxTexts
                group-continued-message="Continuat de pe pagina anterioara"
                group-continues-message="Continuat pe pagina urmatoare"
            />
        </DxGrouping>
        <DxGroupPanel :visible="true" emptyPanelText="Trage aici o coloana pentru a grupa datele" />
        <DxLoadPanel :enabled="true" text="Loading..." :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxStateStoring :enabled="true" :filterValue="false" storage-key="dsLiniiDocumente" />
        <DxColumnChooser :enabled="true" title="Selector coloane" :allowSearch="true" sortOrder="asc" />
        <DxSearchPanel :visible="true" :width="240" placeholder="Cauta ..." />
        <DxPaging :page-size="10" :page-index="0" />

        <DxToolbar>
            <DxItem location="before" template="filterToggleTemplate" />
            <DxItem location="before" template="periodToggleTemplate" />
            <DxItem location="before" template="documentToggleTemplate" />
            <DxItem name="searchPanel" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
        </DxToolbar>

        <DxColumn data-field="Numar" caption="Numar document" cell-template="documentLinkTemplate" />
        <DxColumn data-field="Categorie" caption="Categorie document" />
        <DxColumn data-field="Tip" caption="Tip document" />
        <DxColumn data-field="Data" caption="Data contabilă" data-type="date" format="yyyy-MM-dd" />
        <DxColumn data-field="Partener" caption="Partener" />
        <DxColumn data-field="Produs" caption="Produs" />
        <DxColumn data-field="Unitate" caption="Unitate" />
        <DxColumn data-field="Cantitate" caption="Cantitate" data-type="number" format="#0.00" />
        <DxColumn data-field="PretUnitar" caption="Pret unitar" data-type="number" format="#0.0000" :allowSearch="false" />
        <DxColumn data-field="Total" caption="Total" data-type="number" format="#0.00" :allowSearch="false" />
        <DxColumn data-field="Valuta" caption="Valuta" />

        <DxColumn caption="Context document">
            <DxColumn data-field="ContractNumar" caption="Numar contract" :visible="false" />
            <DxColumn data-field="Proiect" caption="Proiect" :visible="false" />
            <DxColumn data-field="Comanda" caption="Comanda" :visible="false" />
            <DxColumn data-field="Zona" caption="Zona" :visible="false" />
            <DxColumn data-field="AgentNume" caption="Agent" :visible="false" />
            <DxColumn data-field="DataDoc" caption="Data document" :visible="false" data-type="date" format="yyyy-MM-dd" />
            <DxColumn data-field="Scadenta" caption="Data scadenta" :visible="false" data-type="date" format="yyyy-MM-dd" />
        </DxColumn>

        <DxColumn caption="Rezumat financiar">
            <DxColumn data-field="Valoare" caption="Valoare" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="ValoareTva" caption="Valoare TVA" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="Tva" caption="TVA %" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="Tvaunitar" caption="TVA unitar" :visible="false" data-type="number" format="#0.0000" :allowSearch="false" />
            <DxColumn data-field="PretTotal" caption="Pret total" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="Pret" caption="Pret" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="ValoarePret" caption="Valoare pret" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="AdaosUnitar" caption="Adaos unitar" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="ValoareAdaos" caption="Valoare adaos" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="Adaos" caption="Adaos" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="PretCuAdaos" caption="Pret cu adaos" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
            <DxColumn data-field="ValoareCuAdaos" caption="Valoare cu adaos" :visible="false" data-type="number" format="#0.00" :allowSearch="false" />
        </DxColumn>

        <DxColumn caption="Loturi & stoc">
            <DxColumn data-field="Lot" caption="Lot" :visible="false" />
            <DxColumn data-field="CodLotIntern" caption="Cod lot intern" :visible="false" />
            <DxColumn data-field="CodLotFurnizor" caption="Cod lot furnizor" :visible="false" />
            <DxColumn data-field="DataExp" caption="Data expirare" :visible="false" data-type="date" format="yyyy-MM-dd" />
            <DxColumn data-field="LotData" caption="Data lot" :visible="false" data-type="date" format="yyyy-MM-dd" />
            <DxColumn data-field="LotFixat" caption="Lot fixat?" :visible="false" cell-template="circleTemplate" :allowSearch="false" />
            <DxColumn data-field="Intrari" caption="Intrari" :visible="false" data-type="number" :allowSearch="false" />
            <DxColumn data-field="Iesiri" caption="Iesiri" :visible="false" data-type="number" :allowSearch="false" />
            <DxColumn data-field="LocDepozitare" caption="Loc depozitare" :visible="false" />
            <DxColumn data-field="GarantieLuni" caption="Garantie luni" :visible="false" data-type="number" :allowSearch="false" />
        </DxColumn>

        <DxColumn caption="Audit">
            <DxColumn data-field="DataCreare" caption="Data creare" :visible="false" data-type="date" format="yyyy-MM-dd" />
            <DxColumn data-field="DataModificare" caption="Data modificare" :visible="false" data-type="date" format="yyyy-MM-dd" />
            <DxColumn data-field="UserCreare" caption="User creare" :visible="false" :allowSearch="false" />
            <DxColumn data-field="UserModificare" caption="User modificare" :visible="false" :allowSearch="false" />
        </DxColumn>

        <template #circleTemplate="{ data }">
            <div class="circle-container">
                <div v-if="data.value" class="circle circle-true">✔</div>
                <div v-else class="circle circle-false"></div>
            </div>
        </template>

        <template #documentLinkTemplate="{ data }">
            <a class="numar-link" @click.prevent="openDocument(data.data)">
                {{ data.value }}
            </a>
        </template>

        <template #filterToggleTemplate>
            <DxButton
                icon="filter"
                text="Filtre"
                styling-mode="contained"
                class="filter-toggle-btn"
                @click="$emit('toggle-filters')"
            />
        </template>

        <template #periodToggleTemplate>
            <DxButton
                icon="event"
                text="Perioadă"
                styling-mode="contained"
                class="filter-toggle-btn"
                @click="$emit('toggle-filters', 'date')"
            />
        </template>

        <template #documentToggleTemplate>
            <DxButton
                icon="doc"
                text="Document"
                styling-mode="contained"
                class="filter-toggle-btn"
                @click="$emit('toggle-filters', 'document')"
            />
        </template>
    </DxDataGrid>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxExport,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxLoadPanel,
  DxPaging,
  DxSearchPanel,
  DxSorting,
  DxStateStoring,
  DxTexts,
  DxToolbar,
  DxItem
} from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue/button';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';

export default defineComponent({
    name: 'LiniiDocumenteView',
    components: {
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxFilterRow,
        DxSearchPanel,
        DxStateStoring,
        DxColumnChooser,
        DxLoadPanel,
        DxPaging,
        DxGrouping,
        DxGroupPanel,
        DxTexts,
        DxExport,
        DxToolbar,
        DxItem,
        DxButton
    },
    props: {
        initialFilters: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dsLiniiDocumente: null as any,
            liniiDataGrid: 'liniiDataGrid',
            externalFilters: null as any
        };
    },
    mounted() {
        this.dsLiniiDocumente = this.createLiniiDataSource();
    },
    watch: {
        initialFilters: {
            handler(newVal) {
                this.loadData(newVal)
            },
            immediate: true
        }
    },
    methods: {
        createLiniiDataSource() {
            return new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_CautareLinii',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + (localStorage.getItem('ERA_Jwt') ?? '')
                        };
                    }
                }
            });
        },
        ensureLiniiDataSource() {
            if (!this.dsLiniiDocumente) {
                this.dsLiniiDocumente = this.createLiniiDataSource()
            }
        },
        loadData(params: any) {
            this.externalFilters = params
            this.ensureLiniiDataSource()
            const rawFilters = Array.isArray(this.externalFilters?.filters) && this.externalFilters.filters.length > 0 ? this.externalFilters.filters : null

            this.dsLiniiDocumente.filter(rawFilters)

            return this.dsLiniiDocumente.reload()
        },
        refreshData() {
            return this.loadData(this.externalFilters)
        },
        onRowDblClick(e: any) {
            if (e.data) {
                this.openDocument(e.data)
            }
        },
        openDocument(data: any) {
            this.$emit('open-document', {
                Id: data.DocumentId,
                Numar: data.Numar,
                Tip: data.Tip,
                Data: data.Data,
                Partener: data.Partener
            })
        }
    }
});
</script>

<style scoped>
.linii-search-container {
  height: 100%;
  padding: 10px;
}

.numar-link {
  color: #2563eb;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}

.numar-link:hover {
  text-decoration: underline;
  color: #1d4ed8;
}

.circle-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.circle-true {
  background-color: #4caf50;
  color: white;
}

.circle-false {
  border: 2px solid #aaa;
}
</style>

<style>
.filter-toggle-btn {
  background-color: white !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  color: #475569 !important;
  height: 36px !important;
  margin-right: 12px;
  transition: all 0.2s ease !important;
}

.filter-toggle-btn:hover {
  color: #ff2c21 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}
</style>
